import "./style.css";

const BtnLink = ({ link }) => {
  return (
    <>
      <a href={link} target="_blank" rel="noreferrer" className="btn-outline">
        nikphp.ru
      </a>
    </>
  );
};

export default BtnLink;
